import styled from 'styled-components';

import { DefaultRendererType } from '@components/Dropdown/DropdownInterface';

const Title = styled.span`
  font-size: 12px;
  opacity: 0.5;
  font-weight: 600;
  color: ${(p) => p.theme.palette.darkGray};
`;
const Container = styled.span`
  display: flex;
  flex-direction: column;
  font-size: 16px;
`;

type RendererProps<Item> = {
  item?: Item;
  placeholder: React.ReactNode;
  getLabel?: (element: Item) => string;
  defaultLabelRender?: DefaultRendererType;
};

// TODO: fix Downshift rendering
export function PlaceholderAndOptionNameRenderer<Item>({
  placeholder,
  item,
  defaultLabelRender,
  getLabel = (item) => String(item),
}: RendererProps<Item>) {
  return item ? (
    <Container>
      <Title>{placeholder}</Title>
      {defaultLabelRender?.(getLabel(item))}
    </Container>
  ) : (
    <span>{placeholder}</span>
  );
}

export default PlaceholderAndOptionNameRenderer;
